import React, { ErrorInfo } from 'react';

interface State {
    hasError: boolean;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export default class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    state = {
        hasError: false,
    };

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error(error);
        console.error(info);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return null;
        }

        return this.props.children;
    }
}
